/* ZilZal — add button of the "bundle & save" block on item pages (snippets/zz-bundle-upsell.liquid). Added Oct 2026.
   A bundle is one variant, so adding it is a plain /cart/add.js. The one-game rule in assets/zz-upsell.js wraps window.fetch: when the
   cart holds another game it opens its own dialog and answers 422, so a refused add needs no message of its own here. Loaded (deferred)
   only on pages where the block is drawn. */
(function () {
  'use strict';
  if (window.__zzu) return;
  window.__zzu = true;
  var U = window.ZZ_UPSELL || {};
  var ROOT = (U.root || '/').replace(/\/$/, '');

  function busy(b, on) { b.disabled = on; b.classList.toggle('is-loading', on); }
  function dialogOpen() { var og = document.getElementById('zz-og'); return !!(og && !og.hidden); }
  function flash(b) {
    var l = b.querySelector('.zzu__lbl > span'), msg = b.getAttribute('data-err');
    if (!l || !msg || b.__flash) return;
    var was = l.textContent; b.__flash = true; l.textContent = msg;
    setTimeout(function () { l.textContent = was; b.__flash = false; }, 2200);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-zzu-add]');
    if (!b || b.disabled) return;
    var vid = parseInt(b.getAttribute('data-vid'), 10);
    if (!vid) return;
    var cents = parseInt(b.getAttribute('data-cents'), 10) || 0;
    var card = b.closest('[data-zzu-card]');
    var img = card && card.querySelector('.zzu__t img');
    busy(b, true);
    /* the floating cart moves on the tap, like the main add button; a refused add puts it back (refresh below) */
    if (window.zzCartFx) window.zzCartFx.add({ n: 1, c: cents, img: img || null });
    fetch(ROOT + '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        busy(b, false); b.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('bxc:cart-updated'));
        setTimeout(function () { b.classList.remove('is-done'); }, 1500);
      })
      .catch(function () {
        busy(b, false);
        if (window.zzCartRefresh) window.zzCartRefresh();
        if (!dialogOpen()) flash(b);
      });
  });

  /* back/forward cache: a restored page must not keep a spinner */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-zzu-add]'), function (b) { busy(b, false); b.classList.remove('is-done'); });
  });
})();
